<template>
  <div class="flex content-section">
    <div class="w-full flex">
      <div
        v-if="sideBarShow"
        class="w-1/2 md:w-60 border-r absolute  md:relative bg-white z-20 md:-mt-4 pt-4  h-screen pr-2 text-sm mr-2"
      >
        <div class=" ">
          <form
            @submit="addFilters()"
            action="javascript:void(0)"
            class="flex flex-col space-y-2 w-full"
          >
            <div
              class="text-black flex justify-between items-center w-full font-medium"
            >
              <span class="flex-1">Detaylı Arama </span>
              <span
                class="md:opacity-0 block md:hidden float-right text-tile"
                @click="sideBarShow = false"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M17.414 16L24 9.414L22.586 8L16 14.586L9.414 8L8 9.414L14.586 16L8 22.586L9.414 24L16 17.414L22.586 24L24 22.586z"
                  />
                </svg>
              </span>
            </div>
            <template v-if="filters.length > 0">
              <div class="flex flex-col  items-start  text-sm my-2">
                <span
                  class="
              border-b
              flex
              justify-between
              space-x-2
              items-center 
              w-full 
              text-xs
              py-1 
            "
                  :key="filter.value"
                  v-for="filter in filters"
                >
                  <template v-if="fieldsMap[filter.name]">
                    <div class="flex space-x-2">
                      <span
                        class="
                        flex
                        items-center
                        space-y-2
                        flex-col
                        cursor-pointer
                        justify-center
                        filter-edit
                      "
                      >
                        <vk-icon
                          icon="pencil"
                          class="  hover:text-green-600"
                          ratio="0.6"
                          @click="filterEdit(filter)"
                        ></vk-icon>
                        <vk-icon
                          icon="close"
                          ratio="0.6"
                          class="hover:text-red-600"
                          @click="filterRemove(filter)"
                        ></vk-icon>
                      </span>

                      <b>{{ fieldsMap[filter.name].display_name }}</b>
                    </div>
                  </template>

                  <div class="flex space-x-2 items-center">
                    <span class="filter-label">
                      {{ filterTypeName(filter.type, filter.value) }}
                    </span>
                    <span
                      class="
                flex
                items-center
                cursor-pointer
                justify-center
                filter-close
              "
                    >
                      <vk-icon
                        icon="close"
                        ratio="0.6"
                        @click="filterRemove(filter)"
                      ></vk-icon>
                    </span>
                  </div>
                </span>
              </div>
              <VDropdown>
                <div
                  title="Filtreyi favorilere ekle"
                  class="text-tile inline-flex cursor-pointer border text-xs  items-center space-x-2 rounded-md border-tile-200 shadow-sm p-1"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    viewBox="0 0 14 14"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="m9 13.5l-3.5-3l-3.5 3v-9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1Z"
                      />
                      <path d="M5 .5h6a1 1 0 0 1 1 1v9" />
                    </g>
                  </svg>
                  <span>Aramayı favorilere ekle</span>
                </div>
                <!-- This will be the content of the popover -->
                <template #popper>
                  <form
                    @submit.prevent="favoriteFilter()"
                    class="p-2 text-xs flex space-x-2"
                  >
                    <input
                      type="text"
                      class="uk-input"
                      required
                      placeholder="Favori listeniz için bir isim"
                      v-model="favoriform.name"
                    />
                    <savebutton title="Kaydet" action="saveFormFavori" />
                  </form>
                </template>
              </VDropdown>

              <span v-if="filterForm.editedId" class="text-sm mb-2"
                >Arama Kriteri Düzeltme</span
              >
              <span v-else class="text-sm mb-2">Yeni Arama Kriteri</span>
            </template>

            <div>
              <select class="uk-select" v-model="filterForm.name">
                <option value="undefined" selected>Seçiniz</option>
                <option
                  :key="field.name"
                  v-for="field in fields"
                  :value="field.name"
                >
                  {{ field.display_name }}
                </option>
              </select>
            </div>

            <div>
              <select
                class="uk-select"
                v-if="fieldsMap[filterForm.name]"
                v-model="filterForm.type"
              >
                <option
                  :value="filterv.id"
                  :key="filterv.id"
                  v-for="filterv in filterTypes"
                >
                  {{ filterv.value }}
                </option>
              </select>
            </div>

            <template v-if="filterForm.name">
              <template v-if="filterForm.type == 11 || filterForm.type == 12">
                <search-item
                  :form="filterForm"
                  :multiple="true"
                  :value="filterForm.value"
                  :input="fieldsMap[filterForm.name]"
                  @changed="(returned) => (filterForm.value = returned.value)"
                  :type="fieldsMap[filterForm.name].component.name"
                />
              </template>
              <template
                v-else-if="
                  filterForm.type == 2 ||
                    filterForm.type == 3 ||
                    filterForm.type == 8 ||
                    filterForm.type == 9
                "
              >
                <input
                  type="text"
                  class="uk-input"
                  v-model="filterForm.value"
                  placeholder="Değer girin"
                />
              </template>
              <template v-else>
                <search-item
                  :form="filterForm"
                  :value="filterForm.value"
                  :input="fieldsMap[filterForm.name]"
                  @changed="(returned) => (filterForm.value = returned.value)"
                  :type="fieldsMap[filterForm.name].component.name"
                />
              </template>
            </template>
            <div class="flex space-x-2">
              <savebutton
                action="addFilters"
                v-if="filterForm.editedId"
                title="Güncelle"
              />
              <savebutton action="addFilters" v-else title="Ara" />
              <span
                class="global-button cursor-pointer"
                v-if="filterForm.editedId"
                @click="filterForm = []"
                >iptal</span
              >
            </div>
          </form>
        </div>

        <FavoriteFilters :table="table" />
      </div>

      <div class="flex-1">
        <div class="flex  flex-1 w-full justify-between space-x-2">
          <div class="md:w-5/6 flex  justify-start items-center space-x-2">
            <button @click="sideBarShow = !sideBarShow" class="">
              <span class="global-button" v-if="sideBarShow">
                <svg class="w-5 h-5" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="m14 18l-6-6l6-6l1.4 1.4l-4.6 4.6l4.6 4.6Z"
                  />
                </svg>
              </span>
              <span v-else class="global-button">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-5 h-5 text-tile-500"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="m19.6 21l-6.3-6.3q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.888T3 9.5q0-2.725 1.888-4.612T9.5 3q2.725 0 4.613 1.888T16 9.5q0 1.1-.35 2.075T14.7 13.3l6.3 6.3zM9.5 14q1.875 0 3.188-1.312T14 9.5q0-1.875-1.312-3.187T9.5 5Q7.625 5 6.313 6.313T5 9.5q0 1.875 1.313 3.188T9.5 14"
                  />
                </svg>
                <span class="hidden md:block">Detaylı Arama</span>
              </span>
            </button>
            <button @click="toggleAutoRefresh" class="global-button">
              {{
                autoRefresh ? "Otomatik Yenilemeyi Durdur" : "Otomatik Yenile"
              }}
            </button>
            <select
              @change="setLimit()"
              v-model="limit"
              class="uk-select"
              style="max-width: 70px"
            >
              <option value>Seçiniz</option>
              <option value="15">15</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="250">250</option>
              <option value="500">500</option>
            </select>
          </div>
          <form
            class="flex items-center  border rounded-lg p-1 self-end   justify-between space-x-2"
            @submit.prevent="filterCustomerName()"
          >
            <input
              style="font-size:12px"
              placeholder="Müşteri adıyla arama"
              v-model="trxCustomerName"
              type="text"
              class="uk-input flex-1 placeholder-text-xs text-xs"
            />
            <savebutton title="Ara" action="filterCustomerName" />
          </form>
        </div>

        <template v-if="loading">
          <div class="root">
            <div class="no-results">
              <vk-spinner v-if="loading" ratio="4"></vk-spinner>
              <h2>Yükleniyor</h2>
              <h6>Yükleniyor lütfen bekleyin</h6>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="mt-4 min-h-screen rounded-lg">
            <form
              autocomplete="off"
              method="post"
              action="javascript:void(0)"
              @submit="multiSearch()"
            >
              <div class="border-b border-gray-200 mb-2  dark:border-gray-700">
                <nav
                  class="flex space-x-2 overflow-x-scroll md:overflow-hidden"
                  aria-label="Tabs"
                  role="tablist"
                >
                  <button
                    type="button"
                    :class="{
                      ' border-tile-500 text-tile-500':
                        'butunislemler' == activeTab,
                    }"
                    class="py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
                    id="tab-butunislemler"
                    @click="
                      changeTab(
                        [
                          {
                            name: 'status_id',
                            type: 11,
                            value: [],
                          },
                        ],
                        'butunislemler'
                      )
                    "
                    data-hs-tab="#butunislemler"
                    aria-controls="butunislemler"
                    role="tab"
                  >
                    BÜTÜN İŞLEMLER
                  </button>

                  <button
                    type="button"
                    :class="{
                      ' border-tile-500 text-tile-500': 'bekleyen' == activeTab,
                    }"
                    class="py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
                    id="tab-bekleyen"
                    @click="
                      changeTab(
                        [
                          {
                            name: 'status_id',
                            type: 12,
                            value: defaultBekleyenFilter,
                          },
                        ],
                        'bekleyen'
                      )
                    "
                    data-hs-tab="#bekleyen"
                    aria-controls="bekleyen"
                    role="tab"
                  >
                    İŞLEM BEKLEYENLER
                  </button>
                  <button
                    type="button"
                    :class="{
                      ' border-tile-500 text-tile-500':
                        'tamamlanan' == activeTab,
                    }"
                    class="py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
                    id="tab-tamamlanan"
                    @click="
                      changeTab(
                        [
                          {
                            name: 'status_id',
                            type: 11,
                            value: [12, 14],
                          },
                        ],
                        'tamamlanan'
                      )
                    "
                    data-hs-tab="#tamamlanan"
                    aria-controls="tamamlanan"
                    role="tab"
                  >
                    TAMAMLANANLAR
                  </button>
                  <button
                    type="button"
                    :class="{
                      ' border-tile-500 text-tile-500': 'iptalred' == activeTab,
                    }"
                    class="py-4 px-1 inline-flex items-center gap-x-2 border-b-2 border-transparent text-sm whitespace-nowrap text-gray-500 hover:text-tile-500 disabled:opacity-50 disabled:pointer-events-none"
                    id="tab-iptalred"
                    @click="
                      changeTab(
                        [
                          {
                            name: 'status_id',
                            type: 11,
                            value: [4, 7, 8, 13],
                          },
                        ],
                        'iptalred'
                      )
                    "
                    data-hs-tab="#iptalred"
                    aria-controls="iptalred"
                    role="tab"
                  >
                    İPTAL & RED
                  </button>
                </nav>
              </div>

              <div class="flex space-x-1">
                <div
                  class="global-button-xs cursor-pointer"
                  @click="
                    ikinciFiltre(
                      [
                        {
                          name: 'type',
                          type: 1,
                          value: 'ÇEKİM',
                        },
                      ],
                      'cekim'
                    )
                  "
                >
                  Çekim
                </div>
                <div
                  class="global-button-xs cursor-pointer"
                  @click="
                    ikinciFiltre(
                      [
                        {
                          name: 'type',
                          type: 1,
                          value: 'YATIRIM',
                        },
                      ],
                      'cekim'
                    )
                  "
                >
                  Yatırım
                </div>
                <div
                  class="global-button-xs cursor-pointer"
                  @click="ikinciFiltre([], 'cekim')"
                >
                  Hepsi
                </div>

                <div
                  class="global-button-xs cursor-pointer"
                  @click="
                    ikinciFiltre(
                      [
                        {
                          name: 'created_at',
                          type: 1,
                          value: 'bugungun',
                        },
                      ],
                      'cekim'
                    )
                  "
                >
                  Bugünün işlemleri
                </div>
                <div
                  v-if="'butunislemler' == activeTab"
                  class="flex items-center self-end justify-end space-x-2"
                >
                  <label class="text-xs">Oluşturulma tarihi</label>
                  <datepicker
                    :input="{ name: 'datepicker' }"
                    :form="{ type: 10 }"
                    @changed="(re) => setDateRange(re)"
                  />
                </div>
              </div>

              <TransactionPage :data="tableData" />
              <h3 class="total-records">
                Toplam Kayıt: {{ total }}
                <template v-if="page">, {{ page }} sayfa</template>
              </h3>
            </form>
            <vk-pagination
              v-if="total > 0"
              :page.sync="page"
              v-on:update:page="getData('pageupdate')"
              :perPage="limit"
              :total="total"
            >
              <vk-pagination-page-prev></vk-pagination-page-prev>
              <vk-pagination-pages></vk-pagination-pages>
              <vk-pagination-page-next></vk-pagination-page-next>
            </vk-pagination>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import datepicker from "../Ui/Search/date.vue";

import httpService from "../../services/http";
import SearchItemVue from "../Ui/SearchItem.vue";
import EventBus from "../Ui/EventBus";
import FavoriteFilters from "./FavoriteFilters";
import TransactionPage from "./TransactionPage.vue";
export default {
  name: "data-table",
  props: {
    table: String,
    permissions: Array | Object,
    detailurl: String,
    tablename: String,
  },
  components: {
    datepicker,
    "search-item": SearchItemVue,
    FavoriteFilters,
    TransactionPage,
  },
  data() {
    return {
      autoRefresh: false,
      refreshInterval: null,
      favoriform: {},
      storedFilterSave: false,
      favoriFormSave: false,
      filterName: null,
      tabId: null,
      multiFilterItem: [],
      modalEditShow: false,
      modalEdit: [],

      filterToEdit: null,
      filterTypes: [
        { id: 1, value: "Eşit olan" },
        { id: 2, value: "İçeren" },
        { id: 3, value: "İçermeyen" },
        { id: 4, value: "Büyük olan" },
        { id: 5, value: "Küçük olan" },
        { id: 6, value: "Büyük ve eşit olan" },
        { id: 7, value: "Küçük ve eşit olan" },
        { id: 8, value: "ile başlayan" },
        { id: 9, value: "ile biten" },
        { id: 10, value: "Arasındakiler" },
        { id: 11, value: "Birden fazla seçim" },
        { id: 12, value: "Birden fazla hariç tut" },
      ],
      loading: false,
      fields: {},
      bulkForm: {},
      trxCustomerName: null,
      bulkFormnew: null,
      fieldsMap: [],
      select_all: false,
      allFields: [],
      sideBarShow: false,
      fieldSearch: null,
      fieldConfig: false,
      page: null,
      limit: 50,
      total: 200,
      allFieldsCheckbox: [],
      sort: {
        type: "desc",
        name: "id",
      },
      filters: [
        {
          name: "status_id",
          type: 12,
          value: [4, 7, 8, 12, 13, 14],
        },
      ],
      selectedFilter: null,
      activeTab: "bekleyen",
      filterForm: {
        name: "",
        type: "",
        value: "",
      },
      tableHead: [],
      multiFilter: [],
      multiFilterStatus: false,
      tableData: [],
      selection: [],
      defaultBekleyenFilter: [4, 7, 8, 12, 13, 14],
    };
  },
  created() {
    if (this.$route.query.q) {
      this.filters = [{ type: 2, name: "name", value: this.$route.query.q }];
    }
    if (this.$root.cache.me.department) {
      if (this.$root.cache.me.department == "risk") {
        this.defaultBekleyenFilter = [1, 2, 4, 7, 8, 13, 14, 16];

        this.filters = [
          {
            name: "status_id",
            type: 12,
            value: this.defaultBekleyenFilter,
          },
        ];
      }
      if (this.$root.cache.me.department == "finance") {
        this.defaultBekleyenFilter = [3, 4, 5, 7, 8, 12, 13, 14];
        this.filters = [
          {
            name: "status_id",
            type: 12,
            value: this.defaultBekleyenFilter,
          },
        ];
      }
    }
    const urlParams = new URLSearchParams(window.location.search);
    let queryParams = false;
    urlParams.forEach((value, key) => {
      queryParams = true;

      this.multiFilterItem[key] = value;
      if (Number.isInteger(value)) {
        this.filters.push({ type: 1, name: key, value: value });
      } else {
        this.filters.push({ type: 2, name: key, value: value });
      }
    });

    if (queryParams) {
      this.getData("multiSearch");
    }

    this.getData("created");
  },

  watch: {
    $route(to, from) {
      this.routeCleaner();
      if (this.$route.query.q) {
        this.filters = [{ type: 2, name: "name", value: this.$route.query.q }];
      }
      this.getData("watch");
    },
    allFieldsCheckbox(data) {
      localStorage.setItem(this.table + "_allFieldsCheckbox", data);
    },
  },

  computed: {
    tableFieldsArray() {
      return this.tableHead;
    },
    allFieldsFiltered() {
      if (this.fieldSearch) {
        return Object.keys(this.allFields).filter((post) => {
          return post.toLowerCase().includes(this.fieldSearch.toLowerCase());
        });
      } else {
        return this.allFields;
      }
    },
  },
  destroyed() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    filterCustomerName() {
      EventBus.$emit("loadingStatus", {
        action: "filterCustomerName",
        loading: true,
      });

      httpService.transaction
        .searchTrx({
          keyword: this.trxCustomerName,
        })
        .then((resp) => {
          if (resp.data.results) {
            const customerIds = resp.data.results.map((e) => e.customer_id);
            this.filters[0]["name"] = "customer_id";
            this.filters[0]["type"] = 11;
            this.filters[0]["value"] = customerIds;
            EventBus.$emit("loadingStatus", {
              action: "filterCustomerName",
              loading: false,
              success: true,
            });
            this.favoriteFilterApply(this.filters);
          } else {
            EventBus.$emit("loadingStatus", {
              action: "filterCustomerName",
              loading: false,
              success: false,
            });
            this.$root.errorMessage("Sonuç bulunamadı");
          }
        });
    },
    setDateRange(date) {
      this.changeTab(
        [
          {
            name: "created_at",
            type: 10,
            value: date.value,
          },
        ],
        "butunislemler"
      );
    },
    toggleAutoRefresh() {
      this.autoRefresh = !this.autoRefresh;

      if (this.autoRefresh) {
        this.refreshInterval = setInterval(this.getData, 60000);
      } else {
        clearInterval(this.refreshInterval);
      }
    },
    getInitialTab() {
      // Sayfa yüklendiğinde, hash değerine göre aktif sekme belirle
      return window.location.hash.slice(1) || "bekleyen";
    },
    ikinciFiltre(data) {
      let filters = [];
      filters.push(this.selectedFilter[0]);
      filters.push(data[0]);
      this.favoriteFilterApply(filters);
    },
    changeTab(filter, tab) {
      this.activeTab = tab;
      this.selectedFilter = filter;
      this.favoriteFilterApply(filter);
    },
    favoriteFilterApply(data) {
      this.filters = data;

      this.getData("favoriteFilterApply");
    },
    favoriteFilter() {
      EventBus.$emit("loadingStatus", {
        action: "saveFormFavori",
        loading: true,
      });

      httpService
        .inlineSave({
          table: "favorite_filters",
          type: "insert",
          inputs: {
            name: this.favoriform.name,
            table: this.table,
            filters: JSON.stringify(this.filters),
          },
        })
        .then((e) => {
          this.favoriFormSave = false;
          this.favoriform.name = null;
          EventBus.$emit("loadingStatus", {
            action: "saveFormFavori",
            loading: false,
            success: true,
          });
          EventBus.$emit("reflesh", true);
        });
    },
    multiSearch() {
      const urlBuild = new URL(
        window.location.origin + window.location.pathname
      );

      this.filters = [];
      Object.keys(this.multiFilterItem).map((mp) => {
        if (this.multiFilterItem[mp]) {
          if (Number.isInteger(this.multiFilterItem[mp])) {
            this.filters.push({
              name: mp,
              value: this.multiFilterItem[mp],
              type: 1,
            });
          } else {
            this.filters.push({
              name: mp,
              value: this.multiFilterItem[mp],
              type: 2,
            });
          }

          urlBuild.searchParams.append(mp, this.multiFilterItem[mp]);
        }
      });
      history.pushState("", "", urlBuild.href);

      this.getData("multiSearch");
    },
    routeCleaner() {
      this.sort = {};
      this.selection = [];
      this.page = null;
      this.filterForm = [];
      this.filters = [];
      this.fieldsMap = [];
      this.tableData = [];
      this.tableHead = [];
      this.bulkForm = {};
      this.multiFilterItem = [];
    },
    getFieldDisplayName(key) {
      if (typeof this.fields === "object" && this.fields !== null) {
        let item = this.fields.find((e) => {
          return e.name == key;
        });

        if (item) {
          return item.display_name;
        }
      }
      return key;
    },
    filterTypeName(id, value) {
      let returntext = "";
      if (this.filterTypes.find((e) => e.id == id)) {
        returntext += this.filterTypes.find((e) => e.id == id).value;
      }
      if (id == 10) {
        return returntext + " : " + value.start + " : " + value.end;
      } else {
        return returntext + " : " + value;
      }
    },
    setLimit() {
      this.limit = parseInt(this.limit);
      this.getData("setLimit");
    },
    changedAction(e) {
      this.bulkForm.new = e;
    },
    multiFilterFormValue(name) {
      if (name) {
        return Object.values(this.filters).find((e) => e.name == name);
      }
      return null;
    },
    multiFilterFormAdd(value, name) {
      this.multiFilterItem[name] = value;
    },
    filterRemove(item) {
      this.filters.splice(this.filters.indexOf(item), 1);
      this.getData("filterRemove");
    },
    addFilters() {
      if (this.filterForm.value) {
        if (this.filterForm.editedId) {
          this.filters.splice(this.filterForm.editedId - 1, 1);
        }

        this.filters.push(this.filterForm);
        this.filterForm = {
          name: "",
          type: "",
          value: "",
        };
        this.getData("addFilters");
      }
    },
    filterEdit(item) {
      this.filterToEdit = item;
      this.filterForm = { ...item };
      this.filterForm.editedId = this.filters.indexOf(item) + 1;
      //   this.filters.splice(this.filters.indexOf(item), 1);
    },
    fieldConfigOpen() {
      this.fieldConfig = true;
      if (!this.allFieldsCheckbox) {
        this.allFieldsCheckbox = [];
        Object.values(this.allFields).forEach((field) => {
          if (this.tableHead[field]) {
            this.allFieldsCheckbox.push(field);
          }
        });
      }
    },
    getData(methodName) {
      EventBus.$emit("loadingStatus", {
        action: methodName,
        loading: true,
      });

      this.$forceUpdate();

      this.loading = true;

      httpService
        .getData({
          table: this.table,
          page: this.page,
          sort: this.sort,
          filters: this.filters,
          limit: this.limit,
          fields: this.allFieldsCheckbox,
        })
        .then((response) => {
          this.fields = response.data.components;

          this.fields.map((field) => {
            this.fieldsMap[field.name] = field;
          });

          if (this.table == response.data.table) {
            this.tableData = response.data.results;
            this.total = 1 * response.data.total;
            if (response.data.page) {
              if (response.data.page > 0) {
                this.page = 1 * response.data.page + 1;
              } else {
                this.page = 0;
              }
            }
            EventBus.$emit("loadingStatus", {
              action: methodName,
              loading: false,
              success: true,
            });

            this.tableHead = response.data.fields;
            this.allFields = response.data.all_fields;
            this.tabId = response.data.tab_field_id;
            setTimeout(() => {
              this.loading = false;
            }, 100);
          } else {
            this.loading = true;
            this.tableData = this.allFields = this.tableHead = [];
          }
        })
        .catch(() => {
          console.log("yarıda kesildi");
        });
    },
    selectAll(checkboxs) {
      this.select_all = !this.select_all;
      if (this.select_all == true) {
        checkboxs.forEach((item) => {
          this.selection.push(item.id);
        });
      } else {
        this.selection = [];
      }
    },
    setSort(a) {
      this.sortType = a;
    },
    setSortItem(a) {
      if (this.sort.type == "asc") {
        this.sort.type = "desc";
      } else {
        this.sort.type = "asc";
      }
      this.sort.name = a;

      this.getData("setSortItem");
    },
  },
  mounted() {
    this.$on("loading", (data) => {
      this.loading = data;
    });
    EventBus.$on("reflesh", () => {
      this.modalEditShow = false;
      this.getData("reflesh");
    });
    EventBus.$on("transactionReload", () => {
      this.modalEditShow = false;
      this.getData("reflesh");
    });
    EventBus.$on("favoriteFilterApply", (data) => {
      this.modalEditShow = false;
      this.favoriteFilterApply(JSON.parse(data));
    });
  },
};
</script>
<style scoped>
.filter-item:hover .filter-close {
  @apply text-red-500;
}

.navclass {
  margin-top: 15px;
  display: block;
}

.filtre-form {
  margin: 0px !important;
  padding-top: 10px;
}

.filters-ul {
  display: block;
  margin: 0px;
  padding: 0px;
}

.filters-ul .filter-label {
  font-size: 11px;
  display: block;
  clear: both;
  color: #ccc;
}

.filters-ul .filter-label:hover {
  color: #222;
}

.filters-ul li {
  display: block;
  border-bottom: 1px solid #eee;
  margin-bottom: 2px;
  min-height: 45px;
  padding: 3px;
}

.filters-ul li b {
  display: block;
  font-size: 11px;
  font-weight: normal;
  float: left;
}

.filters-ul .uk-icon {
  cursor: pointer;
}

.field-labels label {
  display: block;
  padding: 5px;
}

.table-name {
  margin-top: 20px;
}

.drag {
  padding: 10px;
  cursor: pointer;
}

.add-item-button {
  cursor: copy;
}

.table-header-nav {
  margin: 0px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  padding: 0px;
  align-items: center;
}

.table-header-nav .excel-import-li {
  align-self: flex-end;
  order: 7;
}

.table-header-nav li {
  display: block;
  align-items: flex-end;

  padding: 5px;
}

.table-header-nav li a {
  color: #222;
  display: block;
  padding: 10px;
  font-size: 12px;
}

.heightoverflow {
}

.total-records {
  margin: 0px;
  padding: 0px;
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 13px;
  color: #999;
  text-transform: uppercase;
}

.filter-close {
  float: right;
}

.flex-row {
  display: flex;
  flex-direction: row;
  margin-left: -15px;
}

.selectedTr {
  background: #f7f8fb;
}

.w-overflow {
  @apply w-full overflow-x-scroll;
}
</style>
